import { Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-financial-currency-editor',
  templateUrl: './financial-currency-editor.component.html',
  styleUrls: ['./financial-currency-editor.component.scss']
})
export class FinancialCurrencyEditorComponent {

  private params: any;
  public selectedCurrency!: string;

  agInit(params: any): void {
    this.params = params;
    this.selectedCurrency = this.params.value;
  }

  getValue(): any {
    return this.selectedCurrency;
  }

  isPopup(): boolean {
    return true;
  }

  onCurrencyChange(): void {
    this.params.api.stopEditing();
  }

}
